module.exports = __webpack_public_path__ + "static/media/P2_S10_1.e34e49e8.png";